export interface ReplaceRule {
  beforeReplace: string;
  afterReplace: string;
}

/**
 * 音声合成用テキスト置換ルール
 * 生成AIが出力する記号や装飾を除去または読み替えし、自然な読み上げを実現
 */
export const SPEECH_REPLACE_RULES = [
  // エージェント表記
  { beforeReplace: 'エージェント:', afterReplace: '' },
  { beforeReplace: 'エージェント；', afterReplace: '' },
  
  // マークダウン記法
  { beforeReplace: '*', afterReplace: '' },
  { beforeReplace: '`', afterReplace: '' },
  
  // リスト記号
  { beforeReplace: '-', afterReplace: '' },
  { beforeReplace: '•', afterReplace: '' },
  { beforeReplace: '◦', afterReplace: '' },
  { beforeReplace: '▪', afterReplace: '' },
  { beforeReplace: '▫', afterReplace: '' },
  { beforeReplace: '○', afterReplace: '' },
  { beforeReplace: '●', afterReplace: '' },
  
  // 装飾記号
  { beforeReplace: '※', afterReplace: '' },
  { beforeReplace: '…', afterReplace: '' },
  { beforeReplace: '～', afterReplace: 'から' },
  { beforeReplace: '〜', afterReplace: 'から' },
  { beforeReplace: '・', afterReplace: '' },
  { beforeReplace: '★', afterReplace: '' },
  { beforeReplace: '☆', afterReplace: '' },
  
  // 矢印記号
  { beforeReplace: '←', afterReplace: '' },
  { beforeReplace: '→', afterReplace: '' },
  { beforeReplace: '↑', afterReplace: '' },
  { beforeReplace: '↓', afterReplace: '' },
  
  // 算術・記号文字
  { beforeReplace: '=', afterReplace: '' },
  { beforeReplace: '+', afterReplace: '' },
  { beforeReplace: '#', afterReplace: '' },
  { beforeReplace: '@', afterReplace: '' },
  { beforeReplace: '&', afterReplace: '' },
  { beforeReplace: '%', afterReplace: 'パーセント' },
  { beforeReplace: '|', afterReplace: '' },
  { beforeReplace: '\\', afterReplace: '' },
  { beforeReplace: '/', afterReplace: '' },
  
  // 括弧類
  { beforeReplace: '<', afterReplace: '' },
  { beforeReplace: '>', afterReplace: '' },
  { beforeReplace: '[', afterReplace: '' },
  { beforeReplace: ']', afterReplace: '' },
  { beforeReplace: '{', afterReplace: '' },
  { beforeReplace: '}', afterReplace: '' },
  { beforeReplace: '^', afterReplace: '' },
  { beforeReplace: '_', afterReplace: '' },

  // 固有名詞
  { beforeReplace: 'UUUM', afterReplace: 'ウーム' },
] satisfies ReplaceRule[];
